module.exports = __webpack_public_path__ + "media/images/emblems/Lenk_im_Simmental-coat_of_arms-fc12433b5c66530e5ce9949e0e768975.svg";